import { Link } from 'react-router-dom'

const lastUpdatedLabel = 'Last updated December 3, 2025'

export function TermsOfServicePage() {
  return (
    <main className="bg-white">
      <div className="mx-auto max-w-4xl px-4 py-12 sm:px-6 lg:px-8">
        <header className="space-y-3">
          <p className="text-sm font-semibold uppercase tracking-wide text-blue-700">
            Legal
          </p>
          <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
          <p className="text-sm text-gray-500">{lastUpdatedLabel}</p>
          <p className="text-base text-gray-600">
            White Gi is a Brazilian Jiu-Jitsu training companion that helps you
            capture techniques, build custom series, and refine your practice.
            These terms explain how you may use the app and what you can expect
            from us.
          </p>
        </header>

        <div className="mt-10 space-y-10">
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Eligibility & User Obligations
            </h2>
            <p className="text-gray-600">
              You must be at least 13 years old and able to form a binding
              agreement to use White Gi. By creating an account you agree to:
            </p>
            <ul className="list-disc space-y-2 pl-5 text-gray-600">
              <li>
                Only submit accurate information you have permission to share.
              </li>
              <li>Use the app for lawful training and coaching purposes.</li>
              <li>
                Respect other practitioners and avoid uploading harmful or
                infringing content.
              </li>
            </ul>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Account Responsibility
            </h2>
            <p className="text-gray-600">
              You are responsible for safeguarding your login credentials and
              for all activity that occurs under your account. Notify us
              immediately if you suspect unauthorized use so we can help secure
              your profile.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              User Content & License
            </h2>
            <p className="text-gray-600">
              You retain ownership of the techniques, notes, and videos you add
              to White Gi. You grant us a limited license to store, process, and
              display that content solely to provide the service to you and your
              teammates, consistent with our{' '}
              <Link
                to="/privacy"
                className="text-blue-700 underline hover:text-blue-800"
              >
                Privacy Policy
              </Link>
              .
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Disclaimer of Warranties
            </h2>
            <p className="text-gray-600">
              White Gi is provided "as is" without warranties of any kind. We do
              not guarantee uninterrupted access, specific training outcomes, or
              error-free content. Use the app at your own discretion and confirm
              techniques with a qualified instructor.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">
              Limitation of Liability
            </h2>
            <p className="text-gray-600">
              To the fullest extent permitted by law, White Gi and its creators
              are not liable for indirect, incidental, or consequential damages
              arising from your use of the app. If you are dissatisfied with the
              service, your sole remedy is to discontinue use.
            </p>
          </section>

          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-gray-900">Contact</h2>
            <p className="text-gray-600">
              Questions about these terms? Email{' '}
              <a
                href="mailto:karmbirchima@gmail.com"
                className="text-blue-700 underline hover:text-blue-800"
              >
                karmbirchima@gmail.com
              </a>{' '}
              and we will respond promptly.
            </p>
          </section>
        </div>
      </div>
    </main>
  )
}
